
import { mapGetters } from 'vuex'
import { ref } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/translation'

export default {
  props: {
    id: { type: String, required: true },
    text: { type: String, required: true },
  },
  setup(props, { emit }) {
    const newKeyword = ref('')
    const keywordSubmit = () => {
      emit('keywordSubmit', newKeyword.value)
    }
    return {
      ...setupTranslationPrefixer('GenericSearchSearch'),
      newKeyword,
      keywordSubmit,
    }
  },
  computed: {
    ...mapGetters({
      keyword: 'generic-search/keyword',
    }),
  },
  mounted() {
    this.$refs.searchInput.focus()
  },
}
